import {doppeActionTypeDefineViewerMetadata} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {doppeActionTypeNavigateMapButton} from './doppe-action-type-navigate-map-button';
import {BymoPageLayout} from '../../components/bymo-page-style/bymo-page-style';
import {DoppeViewerModalPanelLayout} from '../../components/doppe-viewer-modal-panel/doppe-viewer-modal-panel';
import {
    DoppeViewerModalOpeningAnimation
} from '../../components/doppe-viewer-modals-controller/doppe-viewer-modals-controller';
import {
    DoppeViewerContactMethodActionsPanel
} from '../../components/doppe-viewer-contact-method-action-panel/doppe-viewer-contact-method-action-panel';
import React from 'react';
import {asyncExecuteInBackground, uuidCreate} from '@wix/devzai-utils-common';
import {DoppeDtoContactMethods} from '../../client-server-common/types/doppe-dto-contact-method';
import {doppeListActionListItemSettingsCreateDefault} from '../../client-server-common';
import {
    doppeDtoContactDetailsDownloadContactCard
} from '../../client-app-and-viewer-common/doppe-dto-contact-details-client/doppe-dto-contact-details-client';

export const doppeActionTypeNavigateMapButtonViewer = doppeActionTypeDefineViewerMetadata(doppeActionTypeNavigateMapButton, {

    getActionButtonProps: actionContext => {

        const action = actionContext.action;
        const {locationCoordinates, displayAddress, showContactPanel} = action.settings;

        // Use displayAddress as the display value for the contact panel
        const displayValue = displayAddress;
        const type = DoppeDtoContactMethods.Location;

        if (showContactPanel) {
            return {
                onClick: () => {
                    actionContext.modalsController.showInnerModal({
                        openingAnimation: bymoPageLayout => {
                            const modalPanelLayout = bymoPageLayout === BymoPageLayout.Wide ?
                                DoppeViewerModalPanelLayout.Inner :
                                DoppeViewerModalPanelLayout.Drawer;

                            switch (modalPanelLayout) {
                                case DoppeViewerModalPanelLayout.Drawer: {
                                    return DoppeViewerModalOpeningAnimation.SlideInFromBottom;
                                }
                                default: {
                                    return DoppeViewerModalOpeningAnimation.FadeIn;
                                }
                            }
                        },
                        content: <DoppeViewerContactMethodActionsPanel
                            title={action.name}
                            type={type}
                            displayValue={displayValue}
                            showNotification={(text: string) => {
                                actionContext.showNotification({
                                    message: text
                                });
                            }}
                            onClick={() => {
                            }}
                            saveAsContact={() => {
                                asyncExecuteInBackground(async () => {
                                    await doppeDtoContactDetailsDownloadContactCard({
                                        media: null,
                                        name: null,
                                        company: '',
                                        notes: '',
                                        jobTitle: '',
                                        contactMethods: [{
                                            type: type,
                                            displayValue: displayValue,
                                            title: '',
                                            media: null,
                                            ...doppeListActionListItemSettingsCreateDefault(uuidCreate()),
                                        }],
                                    });
                                }, {});
                            }}
                        />
                    });
                },
            };
        }
        else {
            const href = generateNavigationUrl({
                locationCoordinates: locationCoordinates,
                displayAddress: displayAddress
            });
            
            return {
                href: href,
                target: '_blank',
                rel: 'noopener',
            };
        }
    }
});

/**
 * Generates a Google Maps directions URL using coordinates or address.
 * Prefers coordinates for accuracy, falls back to display address.
 */
function generateNavigationUrl(
    options: {
        locationCoordinates: { latitude: number; longitude: number } | null;
        displayAddress: string;
    }
): string | undefined {
    const {locationCoordinates, displayAddress} = options;
    
    // Use coordinates if available (more accurate)
    if (locationCoordinates) {
        return `https://www.google.com/maps/dir/?api=1&destination=${locationCoordinates.latitude},${locationCoordinates.longitude}`;
    }
    
    // Fallback to display address
    if (displayAddress) {
        return `https://www.google.com/maps/dir/?api=1&destination=${encodeURI(displayAddress)}`;
    }
    
    return undefined;
}
